export default __webpack_public_path__ + "static/media/logo-privacidade-voce-blue.d6efceab.png";